import { Person, Role } from 'types';

import { ApiGroup } from 'views/Widgets/Filters/AdvancedSpecializedFilter/types';

export class RoleUtil {
  static EDITABLE_ROLES = new Set([
    Role.HR_ADMIN,
    Role.DEVELOPMENT_PLAN_ADMIN,
    Role.ONE_ON_ONE_ADMIN,
    Role.CALIBRATION_VIEW_EDITOR,
  ]);
  static WITH_TARGET_AUDIENCE_ROLES = new Set([
    Role.HR_ADMIN,
    Role.ONE_ON_ONE_ADMIN,
    Role.CALIBRATION_VIEW_EDITOR,
  ]);

  public static properties(role: Role): {
    withTargetAudience: boolean;
    withDevelopmentPlanTemplates: boolean;
    withTargetCampaigns: boolean;
    editable: boolean;
    withCalibrationViewAdmin: boolean;
  } {
    return {
      editable: RoleUtil.EDITABLE_ROLES.has(role),
      withTargetAudience: RoleUtil.WITH_TARGET_AUDIENCE_ROLES.has(role),
      withDevelopmentPlanTemplates: role === Role.DEVELOPMENT_PLAN_ADMIN,
      withTargetCampaigns: role === Role.CALIBRATION_VIEW_EDITOR,
      withCalibrationViewAdmin: role === Role.HR_ADMIN,
    };
  }
}

export type PersonRoleConfig = {
  target_audience?: ApiGroup;
  target_development_plans?: string[];
  // Campaign ids the role is scoped to; empty means every campaign
  target_campaigns?: number[];
  calibration_view_admin?: boolean;
};

export type PersonRole = {
  id: number;
  person: Person;
  role: Role;
  config: PersonRoleConfig;
};

export type PersonRolePostApi = {
  id?: number;
  person: number;
  role: Role;
  config: PersonRoleConfig;
};
